/**
 * HACİM GÖSTERİMİ — "0" ile "veri yok" AYRI şeylerdir.
 *
 * Neden: brief'lerde hacim 0 görününce kullanıcı aracın bozuk olduğunu düşünüyordu.
 * Oysa iki farklı durum tek "0" ile gösteriliyordu:
 *   a) kelimenin hedef ülkede ölçülen araması yok,
 *   b) veri sağlayıcıda o kelime için KAYIT YOK (uzun kuyruk ifadelerde sık).
 * (b) durumunda Semrush gibi araçlar kendi tahmin modelleriyle bir sayı gösterebiliyor;
 * biz uydurmuyoruz — bunun yerine varsa DÜNYA GENELİ hacmi gösterip durumu adıyla yazıyoruz.
 */

const fmt = (n: number) => (n >= 10000 ? `${(n / 1000).toFixed(0)}k` : n >= 1000 ? `${(n / 1000).toFixed(1)}k` : String(Math.round(n)));

export function HacimRozeti({ volume, globalVolume, difficulty, buyuk }: {
  volume: number;
  globalVolume?: number | null;
  difficulty?: number;
  buyuk?: boolean;
}) {
  const zorlukNotu = difficulty && difficulty > 0 ? ` · zorluk ${difficulty}` : "";
  const boyut = buyuk ? "text-3xl" : "text-2xl";

  if (volume > 0) {
    return (
      <>
        <div className={`${boyut} font-bold tabular-nums text-success-600 dark:text-success-400`}>{fmt(volume)}</div>
        <div className="text-[10px] text-muted-foreground">aylık arama{zorlukNotu}</div>
      </>
    );
  }
  if (globalVolume && globalVolume > 0) {
    return (
      <>
        <div className={`${boyut} font-bold tabular-nums text-muted-foreground`}>{fmt(globalVolume)}</div>
        <div className="text-[10px] text-muted-foreground">dünya geneli/ay · ülkede veri yok{zorlukNotu}</div>
      </>
    );
  }
  return (
    <>
      <div className={`${boyut} font-bold tabular-nums text-muted-foreground`}>—</div>
      <div className="text-[10px] text-muted-foreground" title="Google Ads ve DataForSEO veritabanında bu ifade için kayıt yok. Sıfır arama demek değil; ölçülemiyor demek.">
        hacim verisi yok{zorlukNotu}
      </div>
    </>
  );
}
